import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'mailboxes',
    routes,
} as IModuleProps;
